import Vue from "vue";
import VueRouter from 'vue-router';
import App from "./App";
import store from './store/index';
import AuthHandler from './components/AuthHandler';
//import MetricsDisplay from './components/MetricsDisplay';
import MetricDataDisplay from './components/MetricDataDisplay';
//import MetricDataDisplay2 from './components/MetricDataDisplay2';
import Commentary from "./components/Commentary"
import Configuration from "./components/Configuration"
import MetricConfiguration from "./components/MetricConfiguration"
import ProgramsConfig from "./components/ProgramsConfig"
import TargetsConfig from "./components/TargetsConfig"
import EditCommentary from "./components/EditComment";
import LandingPage from "./components/LandingPage";
import LoggedOut from "./components/LoggedOut"
import BootstrapVue from 'bootstrap-vue';
import MomentVue from 'vue-moment';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-css-only/css/bootstrap.min.css'; 
import 'mdbvue/build/css/mdb.css';
import "./assets/css/app-global.css";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faPencilAlt, faQuestionCircle, faTrashAlt, faTimes, faExpandAlt, faCompressAlt, faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Notifications from 'vue-notification'
// import VueAutosuggest from "vue-autosuggest";

// Vue.use(VueAutosuggest);
library.add(faUserSecret, faPencilAlt, faTrashAlt, faQuestionCircle, faTimes, faExpandAlt, faCompressAlt, faPaperPlane)
Vue.component('font-awesome-icon', FontAwesomeIcon)

if (window && window.location.href.indexOf("localhost") === -1 ) {
  console.log = () => {};
  console.info = () => {};
}

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(MomentVue);
Vue.use(Notifications)
Vue.config.productionTip = false;
export const router = new VueRouter({
  mode: 'history',
  routes: [
    {path: '/', component: LandingPage},
    {path: '/oauth2/callback', component: AuthHandler},
    {path: '/metrics', component: MetricDataDisplay},
    {path: '/commentary', name: 'commentary', component: Commentary},
    {path: '/configuration', name: 'Configuration', component: Configuration},
    {path: '/metricConfig', name: 'metricConf', component: MetricConfiguration},
    {path: '/programsConfig', name: 'programsConfig', component: ProgramsConfig},
    {path: '/targetsConfig', name: 'targetsConfig', component: TargetsConfig},
    {path: '/editComment', name: 'editComment', component: EditCommentary},
    {path: '/loggedOut', component: LoggedOut}
  ]
})
new Vue({
  router: router,
  store: store,
  render: h => h(App) 
}).$mount("#App")